export type ApexChartGlobals = {
  labels?: string[];
  series: number[];
  seriesTotals: number[];
  colors?: string[];
  seriesNames?: string[];
  categoryLabels?: string[];
};

export type ApexChartContext = {
  globals: ApexChartGlobals;
  config: Record<string, unknown>;
};

export type DonutTooltipParams = {
  series: number[];
  seriesIndex: number;
  dataPointIndex: number;
  w: ApexChartContext;
};

export type LineTooltipParams = {
  series: number[][];
  seriesIndex: number;
  dataPointIndex: number;
  w: ApexChartContext;
};

export type ChartLegendFormatterOpts = {
  seriesIndex: number;
  w: ApexChartContext;
};

export function formatAxisLabel(value: string | number): string {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (num == null || isNaN(num)) return '';
  if (Number.isInteger(num)) return num.toLocaleString();
  return Number(num.toFixed(2)).toLocaleString();
}

export function formatTooltipValue(value: number): string {
  if (value == null || isNaN(value)) return '';
  if (Number.isInteger(value)) return value.toLocaleString();
  return Number(value.toFixed(2)).toLocaleString();
}
